<app-header></app-header>
<app-sidebarmenu></app-sidebarmenu>
<div class="main-content">
    <router-outlet />
</div>
<app-footer></app-footer>
<app-scroll-button></app-scroll-button>
@if (isChatbotVisible) {
<app-chatbot></app-chatbot>
}